import { Component, OnInit, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';

import { PuiLayoutService, PuiLayoutPlacement } from '../../../core/index';

@Component({
  selector: 'pui-status-bar',
  templateUrl: 'status-bar.component.html'
})
export class PuiStatusBarComponent implements OnInit {
  @ViewChild('footer', { read: ViewContainerRef }) footerContainer: ViewContainerRef;

  constructor(private layoutService: PuiLayoutService,
    private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    const registeredFooter = this.layoutService.get(PuiLayoutPlacement.Footer);
    if (registeredFooter && this.footerContainer) {
      const footerComponent = this.componentFactoryResolver.resolveComponentFactory(registeredFooter);
      if (footerComponent) {
        setTimeout(() => {
          this.footerContainer.createComponent(footerComponent);
        });
      }
    }
  }
}
